export const MSPA_ELEMENTS = {
	SALE_OPT_OUT: 1,
	SHARING_OPT_OUT: 2,
	TARGETED_ADVERTISING_OPT_OUT: 3,
	PERSONAL_DATA_CONSENTS: 4
}

export const MSPA_ELEMENT_ITEMS = [
	{
		value: MSPA_ELEMENTS.SALE_OPT_OUT,
		text: 'Sale Opt-Out'
	},
	{
		value: MSPA_ELEMENTS.SHARING_OPT_OUT,
		text: 'Sharing Opt-Out'
	},
	{
		value: MSPA_ELEMENTS.TARGETED_ADVERTISING_OPT_OUT,
		text: 'Targeted Advertising Opt-Out'
	},
	{
		value: MSPA_ELEMENTS.PERSONAL_DATA_CONSENTS,
		text: 'Personal Data Consents'
	}
]
export function getMspaLabel (id) {
	return MSPA_ELEMENT_ITEMS.find(e => e.value === id)?.text ?? ''
}

export const MSPA_DEFAULT_CHANNEL_GUIDS = {
	SALE_OPT_OUT: '51210ece-4514-4a1b-9c55-9649e9f21ed3',
	SHARING_OPT_OUT: '0168eb2a-df0e-44d6-8f85-c634b4c6444f',
	TARGETED_ADVERTISING_OPT_OUT: '6aaae292-21d2-4520-8031-7b8499866c4a'
}
